export { default as Uploaded } from './uploaded.svg';
export { default as PDF } from './pdf.png';
export { default as NationalID } from './nationalId.svg';
export { default as UploadedCheck } from './uploadedCheck.svg';
export { default as Trash } from './trash.svg';
export { default as CalculatorIcon } from './calc.svg';
export { default as UploadDocs } from './uploadDocs.svg';
export { default as IDIcon } from './idIcon.svg';
export { default as ValuSvg } from './valuSVG.svg';
